export class ToEmpReq{
    unitId:number;
    departmentId:number;
}